import { render } from "./PrepareTab.vue?vue&type=template&id=412608a3&scoped=true"
import script from "./PrepareTab.vue?vue&type=script&lang=js"
export * from "./PrepareTab.vue?vue&type=script&lang=js"

import "./PrepareTab.vue?vue&type=style&index=0&id=412608a3&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2531651810/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412608a3"]])

export default __exports__